import { render } from "./Header.vue?vue&type=template&id=0747d0aa&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=0747d0aa&lang=scss&scoped=true"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0747d0aa"]])

export default __exports__